import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from "@material-ui/core/Button";

class ConfirmationDialog extends React.Component {
/*
    <DialogContentText>
        Parent: {this.props.parent ? this.props.parent.name : "None"}
    </DialogContentText>
 */

  // TODO Input requirement type: Feature, Story, etc depending on the parent type.
  render() {
    return (
        <Dialog open={!!this.props.open} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
            <DialogContent>
                {this.props.text}
            </DialogContent>
            <DialogActions>
                <Button onClick={this.props.onCancel}>
                    Cancel
                </Button>
                <Button onClick={this.props.onOK} color="primary">
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
  }
}

export default ConfirmationDialog;
